/**
 * Prefstest Primary Navigation
 * ─────────────────────────
 * Manages hamburger drawer toggle, mobile sub-menu accordion,
 * desktop dropdown keyboard accessibility, scroll-up sticky behavior,
 * and transparent overlay scroll detection.
 * Uses event delegation. No dependencies.
 */
(function () {
  'use strict';

  /* =======================================================================
     1. Hamburger drawer toggle
     ======================================================================= */
  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-prefstest-nav-hamburger]');
    if (!btn) return;

    const nav = btn.closest('[data-prefstest-nav]');
    if (!nav) return;

    const drawerId = btn.getAttribute('aria-controls');
    const drawer = drawerId ? document.getElementById(drawerId) : nav.querySelector('[data-prefstest-nav-drawer]');
    if (!drawer) return;

    const isOpen = btn.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      btn.setAttribute('aria-expanded', 'false');
      drawer.hidden = true;
    } else {
      btn.setAttribute('aria-expanded', 'true');
      drawer.hidden = false;
    }
  });

  /* =======================================================================
     2. Mobile drawer sub-menu accordion
     ======================================================================= */
  document.addEventListener('click', function (event) {
    const toggle = event.target.closest('[data-prefstest-nav-drawer-toggle]');
    if (!toggle) return;

    const sublist = toggle.nextElementSibling;
    if (!sublist) return;

    const isOpen = toggle.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      toggle.setAttribute('aria-expanded', 'false');
      sublist.hidden = true;
    } else {
      toggle.setAttribute('aria-expanded', 'true');
      sublist.hidden = false;
    }
  });

  /* =======================================================================
     3. Desktop dropdown — keyboard and focus management
     ======================================================================= */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    const openDropdown = document.querySelector('[data-prefstest-nav-trigger][aria-expanded="true"]');
    if (!openDropdown) return;

    openDropdown.setAttribute('aria-expanded', 'false');
    openDropdown.focus();
  });

  /* Close dropdowns when clicking outside */
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-prefstest-nav-trigger]')) return;
    if (event.target.closest('[data-prefstest-nav-dropdown]')) return;

    const openTriggers = document.querySelectorAll('[data-prefstest-nav-trigger][aria-expanded="true"]');
    for (let i = 0; i < openTriggers.length; i++) {
      openTriggers[i].setAttribute('aria-expanded', 'false');
    }
  });

  /* Close drawer when clicking outside nav */
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-prefstest-nav]')) return;

    const openBtns = document.querySelectorAll('[data-prefstest-nav-hamburger][aria-expanded="true"]');
    for (let i = 0; i < openBtns.length; i++) {
      const drawerId = openBtns[i].getAttribute('aria-controls');
      const drawer = drawerId ? document.getElementById(drawerId) : null;
      openBtns[i].setAttribute('aria-expanded', 'false');
      if (drawer) drawer.hidden = true;
    }
  });

  /* =======================================================================
     4. Scroll-up sticky behavior
     ======================================================================= */
  let lastScrollY = 0;
  let scrollUpNavs = [];

  function initScrollUp() {
    scrollUpNavs = document.querySelectorAll('[data-prefstest-nav-sticky="scroll-up"]');
  }

  function handleScroll() {
    // In design mode: keep all navs visible, skip scroll-up hide
    if (window.Shopify && window.Shopify.designMode) return;

    if (scrollUpNavs.length === 0) return;

    const currentY = window.pageYOffset || document.documentElement.scrollTop;

    for (let i = 0; i < scrollUpNavs.length; i++) {
      const nav = scrollUpNavs[i];
      if (currentY <= 0) {
        nav.classList.remove('prefstest-nav--hidden');
      } else if (currentY > lastScrollY) {
        nav.classList.add('prefstest-nav--hidden');
      } else {
        nav.classList.remove('prefstest-nav--hidden');
      }
    }

    lastScrollY = currentY;
  }

  /* =======================================================================
     5. Transparent overlay — add bg on scroll
     ======================================================================= */
  let transparentNavs = [];

  function initTransparent() {
    transparentNavs = document.querySelectorAll('.prefstest-nav--transparent');
  }

  function handleTransparentScroll() {
    // In design mode: keep transparent nav in non-scrolled state for editing
    if (window.Shopify && window.Shopify.designMode) return;

    if (transparentNavs.length === 0) return;

    const scrolled = (window.pageYOffset || document.documentElement.scrollTop) > 50;

    for (let i = 0; i < transparentNavs.length; i++) {
      if (scrolled) {
        transparentNavs[i].classList.add('prefstest-nav--scrolled');
      } else {
        transparentNavs[i].classList.remove('prefstest-nav--scrolled');
      }
    }
  }

  /* =======================================================================
     6. Dropdown color token injection
     ======================================================================= */
  function initDropdownColors() {
    const navs = document.querySelectorAll('[data-prefstest-nav]');
    for (let i = 0; i < navs.length; i++) {
      const nav = navs[i];
      const section = nav.closest('.shopify-section');
      if (!section) continue;

      /* Read dropdown colors from the section's inline style block or data attributes */
      const style = getComputedStyle(section);
      /* Colors are set via CSS custom properties in the section markup */
    }
  }

  /* =======================================================================
     7. Cart drawer integration
     ======================================================================= */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-prefstest-cart-open]');
    if (!btn) return;

    event.preventDefault();
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    } else if (window.kachingCartApi) {
      kachingCartApi.openCart();
    } else {
      /* Fallback: navigate to cart page if no drawer available */
      window.location.href = '/cart';
    }
  });

  /* =======================================================================
     8. Initialization
     ======================================================================= */
  function initAll() {
    initScrollUp();
    initTransparent();
    initDropdownColors();

    if (scrollUpNavs.length > 0 || transparentNavs.length > 0) {
      let ticking = false;
      window.addEventListener('scroll', function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            handleScroll();
            handleTransparentScroll();
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
